
import { Box } from "@chakra-ui/react"
import { GamCampaignForm } from "./gamCampaignForm"


export const GamCampaignSetupPage = () => {

    return (
        <Box mb={20}>
            <GamCampaignForm />
        </Box>
    )
}
